import { useCallback, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { getTranslation } from '../api/api';
import { HttpStatus } from '../api/http';

export interface Translation {
  appTitle: string;
}

interface TranslationContext {
  isLoaded: boolean;
  data: Translation | undefined;
}

export function useTranslation(): TranslationContext {
  const auth = useAuth();
  const isAuthenticated = auth.isAuthenticated && !auth.isLoading && !auth.error;

  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState<Translation | undefined>();

  useEffect(() => {
    if (isAuthenticated && !isLoading && !isLoaded && !data) {
      const accessToken = auth?.user?.access_token ?? '';
      fetchTranslation(accessToken);
    }
  }, [isAuthenticated, isLoading, isLoaded]);

  const fetchTranslation = useCallback(async (accessToken: string) => {
    setIsLoading(true);

    const response = await getTranslation({ accessToken });

    if (response.status === HttpStatus.OK) {
      const translation = await response.json();
      setData(translation);
    }

    setIsLoading(false);
    setIsLoaded(true);
  }, []);

  return { isLoaded, data };
}
